<video width="100%" controls>
  <source [src]="videoUrl" type="video/mp4">
  <!-- <source src="https://youtu.be/HSsqzzuGTPo" type="video/ogg"> -->
</video>
